import React, {FC, memo, useEffect, useState} from 'react';
import cn from 'classnames';
import {GxIcon} from '@garpix/garpix-web-components-react';
import {AsyncPaginate} from 'react-select-async-paginate';
import {useStoreon} from 'storeon/react';
import { getLoadUserOptions } from '@/apps/Applications/helpers';
import { ISelectedUserState } from '@/types';
import { Events, State } from '@/interfaces';
import { SingleValue } from 'react-select';
import {customSelectUserStyles} from '../../apps/Applications/consts';
import styles from './styles/index.module.scss';
import {SearchIcon} from '../../assets';

interface ISelectUser {
  className?: string,
  onChange?: (e:SingleValue<ISelectedUserState>)=>void,
}

const SelectUser: FC<ISelectUser> = ({ className, onChange }) => {
  const {dispatch, selectedUser} = useStoreon<State,Events>('ordersInfo','selectedUser');
  const [value, setValue] = useState<ISelectedUserState | null>(selectedUser);


  const loadOptions = (search: string) => {
    return getLoadUserOptions({search})
  }

  const handleChangeSelect = (item: SingleValue<ISelectedUserState>)=> {
    if(onChange) onChange(item)
    if(item){
      dispatch('selectedUser/set', item)
    } else {
      setValue(item)
      dispatch('selectedUser/set', undefined)
      dispatch('statusCreateMultiOrders/set', false);

    }
  }
  useEffect(()=>{
    if(selectedUser){
      setValue(selectedUser);
    }
  },[selectedUser])

  return (
    <label htmlFor='search-input' className={cn(styles['search--group'], className)}>
      <div className={styles['search--icon']}>
        <GxIcon src={SearchIcon}/>
      </div>
      <AsyncPaginate
        value={value}
        defaultValue={value}
        placeholder='Выберите контрагента'
        loadOptions={loadOptions}
        onChange={(e: SingleValue<ISelectedUserState>)=>handleChangeSelect(e)}
        isClearable
        additional={{
          page: 1,
        }}
        debounceTimeout={500}
        styles={customSelectUserStyles}
        noOptionsMessage={()=>'Ничего не найдено'}
        loadingMessage={()=>'Поиск...'}
      />
    </label>
  );
}

export default memo(SelectUser);